import React from 'react';
import PropTypes from 'prop-types';
import { notification, Button, } from 'antd';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from './reducer';
import saga from './saga';

import {
    makeSelectWidgetIsOpen,
    makeSelectCheckInputData
} from './selectors'

import {
  openWidget,
  closeWidget,
  openModal,
} from './actions'

import configs from 'configs';

import './styles.scss';
import 'antComponentsStyle';

class PrescoringWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleGo = this.handleGo.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      if (this.props.isOpen) {
        this.openNotification();
      } else {
        notification.close("creditCheck");
      }
    }
  }

  openNotification = () => {
    notification.open({
      key: "creditCheck",
      message: "Scopri quali sono le offerte più adatte al tuo cliente!",
      description: <>
        <div>
          In pochi semplici passi potrai effettuare una prima verifica creditizia del tuo cliente e capire le offerte più adatte da proporgli.
        </div>
        <Button
          type="primary"
          onClick={() => this.handleOpen()}
          className="mt-4"
        >Inizia</Button>
      </>,
      duration: 0,
      placement: "bottomRight",
      bottom: '55%',
      onClose: this.props.closeWidget,
      style: {
        width: 280,
        marginLeft: 87,
      },
    });
  };

  handleOpen = () => {
    this.props.closeWidget();
    this.props.openModal();
  }

  handleGo = () => {
    if (this.hasPrescoringResponse()) {
      this.props.openModal();
    } else {
      this.props.openWidget();
    }
  };

  handleKeyboard = ev => {
    if (ev.keyCode === 13) {
      this.handleGo();
    }
  };

  hasPrescoringResponse = () => this.props.inputData.toJS().contractualCategory !== null;

  render() {
    return (
      <div id="prescoring-tool-widget">
        <Button
          type={this.hasPrescoringResponse() ? 'default' : 'primary'}
          size="large"
          onClick={this.handleGo}
          onKeyDown={this.handleKeyboard}
        >
          <i className="os-icon os-icon-dollar-sign" />
          {configs.messages["app.components.PrescoringTool"].widgetLabel}
        </Button>
      </div>
    );
  }
}

PrescoringWidget.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

const withReducer = injectReducer({ key: 'prescoring', reducer });
const withSaga = injectSaga({ key: 'prescoring', saga });

const mapStateToProps = createStructuredSelector({
  isOpen: makeSelectWidgetIsOpen(),
  inputData: makeSelectCheckInputData(),
});

export function mapDispatchToProps(dispatch) {
  return {
    openWidget: () => dispatch(openWidget()),
    closeWidget: () => dispatch(closeWidget()),
    openModal: () => dispatch(openModal()),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withSaga,
  withReducer,
  withConnect,
)(PrescoringWidget);
